import { render, staticRenderFns } from "./PointsLedgerPanel.vue?vue&type=template&id=a71d2fc8&scoped=true&"
import script from "./PointsLedgerPanel.vue?vue&type=script&lang=js&"
export * from "./PointsLedgerPanel.vue?vue&type=script&lang=js&"
import style0 from "./PointsLedgerPanel.vue?vue&type=style&index=0&id=a71d2fc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71d2fc8",
  null
  
)

export default component.exports